import { MenuItem, Select, SelectChangeEvent } from '@mui/material';
import React from 'react';

export enum ViewMode {
  UPCOMING = 'upcoming',
  PAST = 'past',
}

interface EventsFilterProps {
  viewMode: ViewMode;
  onViewModeChange: (newMode: ViewMode) => void;
}

const EventsFilter: React.FC<EventsFilterProps> = ({ viewMode, onViewModeChange }) => {
  const handleChange = (event: SelectChangeEvent<ViewMode>) => {
    onViewModeChange(event.target.value as ViewMode);
  };

  return (
    <Select
      value={viewMode}
      onChange={handleChange}
      size="small"
      sx={{
        minWidth: 150,
      }}
    >
      <MenuItem value={ViewMode.UPCOMING}>Upcoming Events</MenuItem>
      <MenuItem value={ViewMode.PAST}>Past Events</MenuItem>
    </Select>
  );
};

export default EventsFilter;
